/**
 * URL builders for company-scoped views.
 *
 * A leaf module on purpose: no React, no Firebase, no imports at all. It started
 * out in Layout.jsx, which imports `../App` for context and `./firebase` for
 * sign-out — importing it from a test would have dragged the whole application
 * graph in and created a cycle (Layout -> App -> pages -> Layout).
 *
 * **Always build company links with these, never with a relative `to`.** The nav
 * lives in a descendant <Routes> mounted under `/companies/:companyId/*`, and a
 * relative target inside a splat route resolves against the matched pathname
 * *including* the splat, so segments accumulate:
 *
 *   /companies/x               + "stakeholders" -> /companies/x/stakeholders
 *   /companies/x/stakeholders  + "waterfall"    -> /companies/x/stakeholders/waterfall
 *
 * The second URL matches no route and renders blank. That made the first click
 * after entering a company work and every click after it fail, clearing only by
 * leaving the company and coming back — reported as "always the 2nd click".
 * An absolute href cannot accumulate, whatever the current depth.
 */

/** `/companies/<id>` or `/companies/<id>/<segment>`. */
export function companyBase(companyId, segment = '') {
  const root = `/companies/${companyId}`;
  return segment ? `${root}/${segment}` : root;
}
